// We need an atom to store.ts the Google Map props; see <GoogleMapWithAtom /> for why.
import { GoogleMapStopsProp } from '@/components/mapping/GoogleMap/GoogleMap';
import { LegendEntry } from '@/components/mapping/MapLegend';
import { MapFriendlyVisit } from '@/components/mapping/VisitsMap/VisitsMap.types';
import { QhpWithLocationInfo } from '@/fetching/api/liveLocations';
import { atomWithSessionStorage, momentAtomWithSessionStorage } from '@/utils/browserStorage';
import { atom } from 'jotai';
import moment from 'moment';
import { z } from 'zod';

export const stopsAtom = atom<GoogleMapStopsProp>([]);
export const qhpsWithLocationInfoAtom = atom<QhpWithLocationInfo[]>([]);

// We use session storage to persist the state between reloads, but not share it across tabs.
//  The visitFiltersAtom also uses session storage.
export const searchTextAtom = atomWithSessionStorage('visitFiltersSearchText', '', z.string());
export const startDateAtom = momentAtomWithSessionStorage('visitFiltersStartDate', moment());
export const endDateAtom = momentAtomWithSessionStorage('visitFiltersEndDate', moment());
// We are using null to correspond to [] statuses and the `All` tab
export const statusAtom = atomWithSessionStorage('visitFiltersStatus', null, z.string().nullable());
export const pageAtom = atomWithSessionStorage('visitFiltersPage', 0, z.number());
export const pageSizeAtom = atomWithSessionStorage('visitFiltersPageSize', 100, z.number());

export const mapFriendlyVisitsAtom = atom<MapFriendlyVisit[]>([]);

export const legendAtom = atom<LegendEntry[]>([]);
